import { Button } from '@sunwebgroup/uds-ui/button'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from 'react-intl'
import { useBookingDetailsActions } from '@/scopes/account/booking-details/infrastructure/dependencies/dependencies'
import { useFeatureFlag } from '@/scopes/common/infrastructure/feature-flags'
import { useBookingDetailsStore } from '../../infrastructure/useBookingDetailsStore'
import { getCanEditPreferences, getIsPreferencesSectionVisible } from '../selectors'
import { BookingDetailsSection } from './BookingDetailsSection'
import { IconRow } from './IconRow'
import styles from './PreferencesSection.module.css'

export function PreferencesSection({ className }: { className?: string }) {
  const { formatMessage } = useIntl()
  const { editPreferencesOpened } = useBookingDetailsActions()
  const preferences = useBookingDetailsStore(state => state.preferences)
  const isEditEnabled = useFeatureFlag('RIO_ENABLE_BOOKING_PREFERENCES_EDIT')
  const canEditPreferences = useBookingDetailsStore(state => getCanEditPreferences(state, isEditEnabled))
  const isVisible = useBookingDetailsStore(state => getIsPreferencesSectionVisible(state, isEditEnabled))

  if (!isVisible) {
    return null
  }

  const title = formatMessage({ id: 'booking_details_preferences_title' })

  return (
    <BookingDetailsSection isSidebar className={className} title={title}>
      {preferences.length > 0 && (
        <div className={styles.list}>
          {preferences.map((preference, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${preference}-${index}`} className={styles.item}>
              <Icon glyph="CircleFilledSmall" size={12} className={styles.icon} />
              <Typography as="div" variant="body-m-regular-tight">{preference}</Typography>
            </div>
          ))}
        </div>
      )}
      {canEditPreferences && (
        <Button
          variant="secondary"
          fullWidth
          className={styles.editButton}
          onClick={editPreferencesOpened}
        >
          {formatMessage({ id: 'booking_details_preferences_edit_title' })}
        </Button>
      )}
      {preferences.length > 0 && (
        <div className={styles.disclaimer}>
          <IconRow
            glyph="InformationInCircle"
            description={formatMessage({ id: 'booking_details_preferences_subject_to_availability' })}
          />
        </div>
      )}
    </BookingDetailsSection>
  )
}
